module.exports = __webpack_public_path__ + "img/Company Profile.7cd99ff3.png";